import React from "react";
import { UIStore } from "src/stores/UIStore";
import { NavigationStore } from "src/stores/NavigationStore";
import { create } from "mobx-persist";
import { AuthStore } from "./AuthStore";
import { ImportUsersProgressModalStore } from "./ImportUsersProgressModalStore";
import { InviteUserProgressModalStore } from "./InviteUserProgressModalStore";
import { CustomerSettingsStore } from "./CustomerSettingsStore";
import { UserAccessStore } from "./UserAccessStore";
import { CustomersOverviewStore } from "./CustomersOverviewStore";
import { TenantAccessStore } from "./TenantAccessStore";
import { CustomerCopyJobsStore } from "./CustomerCopyJobsStore";
import { CustomerDetailPageStore } from "./CustomerDetailPageStore";

export const hydrate = create({
    storage: localStorage,
    jsonify: true
});

export class RootStore {
    uiStore = new UIStore();
    navStore = new NavigationStore();
    authStore = new AuthStore();

    importUsersProgressModalStore: ImportUsersProgressModalStore;
    inviteUserProgressModalStore: InviteUserProgressModalStore;
    customerSettingsStore: CustomerSettingsStore;
    userAccessStore: UserAccessStore;
    customersOverviewStore: CustomersOverviewStore;
    tenantAccessStore: TenantAccessStore;
    customerCopyJobsStore: CustomerCopyJobsStore;
    customerDetailPageStore: CustomerDetailPageStore;

    constructor() {
        // Pass 'this' to the ImportUsersProgressModalStore constructor
        this.importUsersProgressModalStore = new ImportUsersProgressModalStore(this);
        this.inviteUserProgressModalStore = new InviteUserProgressModalStore(this);
        this.customerSettingsStore = new CustomerSettingsStore(this);
        this.tenantAccessStore = new TenantAccessStore(this);
        this.userAccessStore = new UserAccessStore(this);
        this.customersOverviewStore = new CustomersOverviewStore(this);
        this.customerCopyJobsStore = new CustomerCopyJobsStore(this);
        this.customerDetailPageStore = new CustomerDetailPageStore(this);
        hydrate("@portal", this.authStore).finally(() => this.authStore.setLoaded(true));
        hydrate("@nav", this.navStore);
    }
}

export const RootStoreContext = React.createContext<RootStore>(undefined!);
